import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "./app/shared/theme-provider.tsx";
import { Toaster } from "react-hot-toast";
import GlobalDrawer from "./app/shared/drawer-views/container.tsx";
import GlobalModal from "./app/shared/modal-views/container.tsx";
import createStore from "react-auth-kit/createStore";
import AuthProvider from "react-auth-kit";
import { IUserData } from "@/utilities/types/Users.ts";
import { AUTH_KIT } from "./config/auth.ts";
import "./locales/i18n";
import { AdvanceFeaturesProvider } from "./utilities/providers/AdvanceFeaturesProvider.tsx";
import { NotificationProvider } from "./components/notification/NotificationContext.tsx";
import { ApiProvider } from "./store/providers/ApiProvider.tsx";
import HelpdeskWidget from "@/components/helpdesk-widget/HelpdeskWidget";
import { registerSW } from "virtual:pwa-register";

const store = createStore<IUserData>({
  authName: AUTH_KIT.NAME,
  authType: "cookie",
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === "https:",
});

// PWA service worker with toast notifications
const toast = (
  message: string,
  options?: { duration?: number; icon?: string },
) => {
  // @ts-expect-error - react-hot-toast
  window.toast?.(message, options);
};

registerSW({
  onNeedRefresh() {
    toast("New version available! Refresh to get the latest updates.", {
      duration: 0,
      icon: "🔄",
    });
  },
  onOfflineReady() {
    toast("App ready to work offline!");
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <AdvanceFeaturesProvider>
    <AuthProvider store={store}>
      <BrowserRouter>
        <ThemeProvider>
          <NotificationProvider>
            <ApiProvider>
              <App />
            </ApiProvider>
            <Toaster containerStyle={{ zIndex: 9999999999 }} />
            <GlobalDrawer />
            <GlobalModal />
            <HelpdeskWidget />
          </NotificationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </AuthProvider>
  </AdvanceFeaturesProvider>,
  // </React.StrictMode>
);
